// import { useDispatch } from "react-redux";
import { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { signInWithEmailAndPassword } from "firebase/auth" 
import { auth } from "../../firebase-config";
import { AuthContext } from "../../Context/AuthContext";
import React from 'react'
import styled from "styled-components";
import Swal from 'sweetalert2'
import Img from "../../img/moha.jpg"
import "./login.scss";


//#region CSS
const FirstContainer = styled.div`
width: 450px;
-webkit-box-shadow: 2px 4px 10px 1px rgba(0, 0, 0, 0.2);
box-shadow: 2px 4px 10px 1px rgba(201, 201,201 0.2);
background-color: black;
@media screen and (max-width: 768px){
   width: 0px;
   height: 100vh;
   
   }
`

const Container = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  @media screen and (max-width: 768px){
    width: 100vw;
    background-color: black;
   }
`;

const Wrapper = styled.div`
  width: 25%;
  padding: 20px;
  background-color: white;
  @media screen and (max-width: 768px){
    width: 320px;
    z-index: 1;
    border-radius: 11px;
   }

`;

const Title = styled.h1`
  font-size: 24px;
  font-weight: 300;
  @media screen and (max-width: 768px){
    text-align: center;
    font-weight: 500;
    font-size: 22px;
   }


`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
`;

const Input = styled.input`
  flex: 1;
  min-width: 40%;
  margin: 10px 0;
  padding: 10px;
  @media screen and (max-width: 768px){
   }

`;
const ButtonContainer = styled.span`
  position: relative;
  width: 100%;
  height: 8vh;

  
`;
const Buttons = styled.button`
  width: 40%;
  border: none;
  padding: 13px 20px;
  background-color: #a68dff;
  color: white;
  cursor: pointer;
  position: absolute;
  top: 0;
  left: 30%;
  transition: 0.5s ease;
  // margin-bottom: 10px;
  @media screen and (max-width: 768px){
    width: 60%;
    left: 20%;
    padding: 11px 16px;
    margin-top: 10px;

   }

  &:hover {
    background-color: #e1f5f5;
    transform: scale(1.05);
    color: #8974d6;
  }

  &:disabled {
    color: #a68dff;
    cursor: not-allowed;
  }
`;

//#endregion

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const { dispatch } = useContext(AuthContext);


  const handleClick = async (e) => {
    e.preventDefault();

    signInWithEmailAndPassword(auth, email, password)
  .then((userCredential) => {
    // Signed in
    const user = userCredential.user;
    dispatch({type:"LOGIN", payload:user})
    Swal.fire({
      position: 'center',
      icon: 'success',
      title: 'Bienvenido',
      showConfirmButton: false,
      timer: 1600
    })
      setTimeout(() => {
        navigate("/admin");
      }, 1600);
    // ...
  })}
  
  return (
    <FirstContainer>
      <Container>
      <div><img src={Img} alt="" className="content"/></div>
        <Wrapper>
          <Title>INICIAR SESIÓN</Title>
          <Form>
            <Input
              placeholder="Usuario"
              type="text"
              name="user"
              onChange={(e) => setEmail(e.target.value)}
            />
            <Input
              placeholder="Contraseña"
              type="password"
              onChange={(e) => setPassword(e.target.value)}
            />
            <ButtonContainer>
              <Buttons onClick={handleClick}>
                ENTRAR
              </Buttons>
            </ButtonContainer>
          </Form>
        </Wrapper>
      </Container>
    </FirstContainer>
  );
};

export default Login;
